import { EMPLOYEE_EXPERIENCE } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';

const employeeExperienceRequest = (method, url, payload) => ({
  url,
  method,
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  ...(payload ? { payload } : {}),
  service: serviceName.PROJECT_MS,
});

export const getEmployeeExperiences = () => employeeExperienceRequest(
  'get',
  `${EMPLOYEE_EXPERIENCE}?cb=${Date.now()}`,
);

export const createEmployeeExperience = (experienceRange, roleIds) => employeeExperienceRequest(
  'post',
  EMPLOYEE_EXPERIENCE,
  { experienceRange, roleIds },
);

export const updateEmployeeExperience = (
  employeeExperienceId, experienceRange, isActive, roleIds,
) => employeeExperienceRequest(
  'put',
  `${EMPLOYEE_EXPERIENCE}/${employeeExperienceId}`,
  {
    experienceRange,
    isActive,
    ...(roleIds !== undefined ? { roleIds } : {}),
  },
);
